import axios from 'axios';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

export default {
  namespaced: true,
  state: {
    employee: {
      profile: null,
      last_position: {
        position: '',
        team: '',
        department: null,
      },
      first_name: '',
      last_name: '',
      sex: '',
      date_of_birth: null,
      country_of_birth: 'EG',
      marital_status: '',
      has_children: false,
      email_address: '',
      mobile_number: '',
      home_telephone_number: '',
      reference_number: '',
      address: '',
      join_date: null,
      contract_expiration_date: null,
      hr_id: '',
      finger_id: '',
      medical_card_id: '',
      alias: '',
      hometown_status: false,
      hurghada_status: false,
      workspace_capacity: '',
      employment_type: '',
      employee_status: true,
      vacation_balance: null,
      sick_leaves: null,
      taken_vacations: null,
      net_balance: null,
      employee_photo: null,
      application: null,
      language_skills: [],
      computer_skills: [],
    },
    summarizedEmployees: [],
    employeeSuggestions: [],
    employeePositions: [],
    employeeNames: [],
    employeeAllNames: [],
  },
  mutations: {
    updateEmployee(state, newEmployee) {
      state.employee = newEmployee;
    },
    resetEmployee(state) {
      state.employee = {
        profile: null,
        last_position: {
          position: '',
          team: '',
          department: null,
        },
        first_name: '',
        last_name: '',
        sex: '',
        date_of_birth: null,
        country_of_birth: 'EG',
        marital_status: '',
        has_children: false,
        email_address: '',
        mobile_number: '',
        home_telephone_number: '',
        reference_number: '',
        address: '',
        join_date: null,
        contract_expiration_date: null,
        hr_id: '',
        finger_id: '',
        medical_card_id: '',
        alias: '',
        hometown_status: false,
        hurghada_status: false,
        workspace_capacity: '',
        employment_type: '',
        employee_status: true,
        vacation_balance: null,
        sick_leaves: null,
        taken_vacations: null,
        net_balance: null,
        employee_photo: null,
      };
    },
    updateSummarizedEmployees(state, newEmployees) {
      state.summarizedEmployees = newEmployees;
    },
    updateEmployeeSuggestions(state, newSuggestion) {
      state.employeeSuggestions = newSuggestion;
    },
    updateEmployeePositions(state, newEmployeePosition) {
      state.employeePositions = newEmployeePosition;
    },
    updateEmployeeNames(state, newNames) {
      state.employeeNames = newNames;
    },
    updateEmployeeAllNames(state, newNames) {
      state.employeeAllNames = newNames;
    },
  },
  actions: {
    saveEmployee(context, formData) {
      const id = formData.get('id');
      const reqMethod = id === '0' ? 'post' : 'put';
      const reqUrl = id === '0'
        ? '/api/employee/create/'
        : `/api/employee/edit/${id}/`;
      return new Promise((resolve, reject) => {
        axios({
          url: reqUrl,
          method: reqMethod,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getEmployee(context, employeeId) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/employee/employee/${employeeId}/`,
          method: 'get',
        }).then((response) => {
          context.commit('updateEmployee', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('resetEmployee');
          reject(error.response.data);
        });
      });
    },
    getSummarizedEmployees(context, pageNumber) {
      console.log('page number:', pageNumber);
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/employee/employees/?page=${pageNumber}`,
          method: 'get',
        }).then((response) => {
          context.commit('updateSummarizedEmployees', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateSummarizedEmployees', []);
          reject(error.response.data);
        });
      });
    },
    getPositions(context, employeeId) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/employee/employee/${employeeId}/position/`,
          method: 'get',
        }).then((response) => {
          context.commit('updateEmployeePositions', response.data);
          console.log(response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateEmployeePositions', {});
          reject(error.response.data);
        });
      });
    },
    getFilteredEmployees(context, serchInput) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/employee/search/',
          method: 'post',
          data: { filter: serchInput },
        }).then((response) => {
          context.commit('updateSummarizedEmployees', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateSummarizedEmployees', []);
          reject(error.response.data);
        });
      });
    },
    getSuggestions(context, inputData) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/employee/search-suggestions/',
          method: 'post',
          data: inputData,
        }).then((response) => {
          context.commit('updateEmployeeSuggestions', response.data.result);
          console.log('response:', response.data);
          resolve(response.data.result);
        }).catch((error) => {
          context.commit('updateEmployeeSuggestions', []);
          reject(error.response.data);
        });
      });
    },
    retrieveEmployeeNames(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/employee/employee-names/',
          method: 'get',
        }).then((response) => {
          context.commit('updateEmployeeNames', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateEmployeeNames', []);
          reject(error.response.data);
        });
      });
    },
    retrieveEmployeeAllNames(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/employee/employee-all-names/',
          method: 'get',
        }).then((response) => {
          context.commit('updateEmployeeAllNames', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateEmployeeAllNames', []);
          reject(error.response.data);
        });
      });
    },
    saveEmployeePosition(context, formData) {
      const id = formData.get('id');
      const reqMethod = id === '0' ? 'post' : 'put';
      const reqUrl = id === '0'
        ? '/api/employee/employee/add-position/'
        : `/api/employee/employee/edit-position/${id}/`;
      return new Promise((resolve, reject) => {
        axios({
          url: reqUrl,
          method: reqMethod,
          data: formData,
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    uploadProfile(context, formData) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/employee/upload-profile/',
          method: 'patch',
          data: formData,
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteEmployeePosition(context, positionId) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/employee/employee/delete-position/${positionId}/`,
          method: 'delete',
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  getters: {
    getEmployee(state) {
      return state.employee;
    },
    getSummarizedEmployees(state) {
      return state.summarizedEmployees;
    },
    getSuggestions(state) {
      return state.employeeSuggestions;
    },
    getEmployeePositions(state) {
      return state.employeePositions;
    },
    getEmployeeNames(state) {
      return state.employeeNames;
    },
    getEmployeeAllNames(state) {
      return state.employeeAllNames;
    },
  },
};
